<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="6">
          <TagComponent
            :label="$lang.education_form.grade"
            category_name="education_grade"
            :idTrack="true"
            :requiredLabel="educationGradeRequired"
            :parentPermissions="parentPermissions"
            :checkValidation="checkEducationGradeSelected"
            :parentValue="educationGrade"
            @updateCheckValidation="updateCheckEducationGradeSelected"
            @getSelected="getEducationGradeSelected"
          />
        </b-col>
        <b-col cols="12" md="6">
          <TagComponent
            v-if="checkCustomKey('isEducationFieldByEnumeration', false)"
            :label="$lang.education_form.field"
            category_name="education_field"
            :idTrack="true"
            :requiredLabel="educationFieldRequired"
            :parentPermissions="parentPermissions"
            :checkValidation="checkEducationFieldSelected"
            :parentValue="educationField"
            @updateCheckValidation="updateCheckEducationFieldSelected"
            @getSelected="getEducationFieldSelected"
          />
          <b-form-group
            v-else
            :label="$lang.education_form.field"
            label-for="education_field"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.education_form.field"
              :rules="$v.education_field.$params"
            />
            <b-form-input
              type="text"
              :autocomplete="$lang.education_form.field"
              v-model="$v.education_field.$model"
              :state="
                $v.education_field.$dirty ? !$v.education_field.$error : null
              "
            >
            </b-form-input>

            <b-form-invalid-feedback id="education_field_feedback"
              >رشته تحصیلی الزامی است
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.education_form.city"
            :label-cols="$config.form.labelCol"
          >
            <selectAsync
              :options="location_options"
              v-model="$v.location_selected.$model"
              label="caption"
              :asyncFind="getLocation"
              :isValid="
                $v.location_selected.$dirty
                  ? !$v.location_selected.$error
                  : null
              "
              :loading="location_loading"
              :placeholder="$lang.search_city"
            />

            <b-form-invalid-feedback
              :style="{
                display: $v.location_selected.$error ? 'block' : 'none',
              }"
              id="gender_id-feedback"
            >
              {{ $lang.error_required | replace($lang.education_form.city) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <TagComponent
            v-if="checkCustomKey('isEducationPlaceByEnumeration', false)"
            :label="$lang.education_form.education_place"
            category_name="education_place"
            :idTrack="true"
            :requiredLabel="educationPlaceRequired"
            :parentPermissions="parentPermissions"
            :checkValidation="checkEducationPlaceSelected"
            :parentValue="educationPlace"
            @updateCheckValidation="updateCheckEducationPlaceSelected"
            @getSelected="getEducationPlaceSelected"
          />
          <b-form-group
            v-else
            :label="$lang.education_form.education_place"
            label-for="education_place"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.education_form.education_place"
              :rules="$v.education_place.$params"
            />
            <b-form-input
              type="text"
              v-model="$v.education_place.$model"
              :autocomplete="$lang.education_form.education_place"
              :state="
                $v.education_place.$dirty ? !$v.education_place.$error : null
              "
            ></b-form-input>

            <b-form-invalid-feedback id="education_place_feedback"
              >محل تحصیل الزامی است
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.education_form.from_year"
            label-for="from_year"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.education_form.from_year"
              :rules="$v.from_year.$params"
            />
            <date-picker
              type="year"
              v-model="$v.from_year.$model"
              :state="$v.from_year.$dirty ? !$v.from_year.$error : null"
              inputReq="true"
              auto-submit
              clearable
              simple
              format="jYYYY"
              display-format="jYYYY"
              :max="new Date() | moment('jYYYY')"
              :class="
                $v.from_year.$dirty
                  ? $v.from_year.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :style="{ display: $v.from_year.$error ? 'block' : 'none' }"
              id="gender_id-feedback"
            >
              {{
                $lang.error_required | replace($lang.education_form.from_year)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.education_form.to_year"
            label-for="to_year"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.education_form.to_year"
              :rules="$v.to_year.$params"
            />
            <date-picker
              type="year"
              v-model="$v.to_year.$model"
              :state="$v.to_year.$dirty ? !$v.to_year.$error : null"
              inputReq="true"
              auto-submit
              simple
              format="jYYYY"
              display-format="jYYYY"
              :min="$v.from_year.$model"
              :max="new Date() | moment('jYYYY')"
              :class="
                $v.to_year.$dirty
                  ? $v.to_year.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :style="{ display: $v.to_year.$error ? 'block' : 'none' }"
              id="gender_id-feedback"
            >
              {{
                $lang.error_required | replace($lang.education_form.to_year)
              }}</b-form-invalid-feedback
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.description"
            label-for="address"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              id="description"
              type="text"
              v-model="$v.description.$model"
              :autocomplete="$lang.description"
              :rows="this.$config.form.textareaRows"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-checkbox
            id="checkbox-1"
            v-model="is_last_grade"
            value="1"
            unchecked-value="0"
          >
            این مدرک به عنوان آخرین مدرک تحصیلی مرتبط قابل نمایش، در نظر گرفته
            شود.
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button class="mr-2" variant="outline-danger" @click="cancel">
              <mdicon name="close" size="24" />
              {{ $lang.close }}
            </b-button>
            <b-button
              v-if="isAdmin(parentPermissions)"
              type="submit"
              variant="success"
            >
              <mdicon name="check" size="24" />
              {{ $lang.submitButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import TagComponent from "@/components/tag/tagComponent.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { isAdmin, checkCustomKey } from "@/shared/utils";
import { pathOr } from "ramda";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  validations: {
    education_field: {
      required: requiredIf(
        () => !checkCustomKey("isEducationFieldByEnumeration", false)
      ),
    },
    education_place: {
      required: requiredIf(
        () => !checkCustomKey("isEducationPlaceByEnumeration", false)
      ),
    },
    location_selected: {},
    from_year: {},
    to_year: {},
    description: {},
    is_last_grade: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    TagComponent,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      is_last_grade: 0,
      location_options: [],
      education_field: null,
      location_selected: null,
      location_loading: false,
      education_place: null,
      from_year: null,
      to_year: null,
      description: null,
      checkEducationFieldSelected: false,
      educationField: null,
      educationGradeRequired: true,
      checkEducationGradeSelected: false,
      educationGrade: null,
      checkEducationPlaceSelected: false,
      educationPlace: null,
    };
  },
  computed: {
    educationFieldRequired() {
      return checkCustomKey("isEducationFieldByEnumeration", false);
    },
    educationPlaceRequired() {
      return checkCustomKey("isEducationPlaceByEnumeration", false);
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchData(value);
        }
      },
    },
  },
  methods: {
    pathOr,
    isAdmin,
    checkCustomKey,
    async getLocation(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.location_options = [];
      }

      try {
        this.location_loading = true;
        const url = `${this.$config.api_url}${this.$config.resources.location}?city=${query}`;
        const response = await this.$httpService.get(url);
        this.location_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.location_loading = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$v.$touch();
      this.checkEducationGradeSelected = true;
      this.checkEducationFieldSelected = true;
      this.checkEducationPlaceSelected = true;
      if (this.$v.$anyError) return;
      if (this.educationGradeRequired && !this.educationGrade) return;
      if (this.educationFieldRequired && !this.educationField) return;
      if (this.educationPlaceRequired && !this.educationPlace) return;

      const payload = {
        is_last_grade: this.is_last_grade,
        from_year: this.from_year,
        to_year: this.to_year,
        description: this.description,
        location_id: pathOr(null, ["id"], this.location_selected),
        education_grade_id: pathOr(null, ["id"], this.educationGrade),
        // get education_field of enum input for moi project
        education_field_id: pathOr(null, ["id"], this.educationField),
        // get education_field of text input for other project
        education_field: this.education_field,
        // get education_place of enum input for moi project
        education_place_id: pathOr(null, ["id"], this.educationPlace),
        // get education_place of text input for other project
        education_place: this.education_place,
      };
      this.$emit("submit", payload);
    },
    async fetchData(item) {
      this.education_field = pathOr(null, ["education_field"], item);
      this.location_selected = {
        id: pathOr(null, ["location", "id"], item),
        caption: pathOr("", ["location", "full_path"], item),
      };
      this.education_place = pathOr(null, ["education_place"], item);
      this.from_year = pathOr(null, ["from_year"], item);
      this.to_year = pathOr(null, ["to_year"], item);
      this.description = pathOr(null, ["description"], item);
      this.is_last_grade = pathOr(null, ["is_last_grade"], item);
      this.educationField = pathOr(null, ["education_field_enum"], item);
      this.educationGrade = pathOr(null, ["education_grade"], item);
      this.educationPlace = pathOr(null, ["education_place_enum"], item);
    },
    getEducationFieldSelected(data) {
      this.educationField = data;
    },
    updateCheckEducationFieldSelected(data) {
      this.checkEducationFieldSelected = data;
    },
    getEducationGradeSelected(data) {
      this.educationGrade = data;
    },
    updateCheckEducationGradeSelected(data) {
      this.checkEducationGradeSelected = data;
    },
    getEducationPlaceSelected(data) {
      this.educationPlace = data;
    },
    updateCheckEducationPlaceSelected(data) {
      this.checkEducationPlaceSelected = data;
    },
  },
};
</script>
